import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getFamily: () => client.get("/family").then((r) => r.data),
  createFamily: (payload) => client.post("/family", payload).then((r) => r.data),
  updateFamily: (payload) => client.put("/family", payload).then((r) => r.data),
  verifyPin: (pin) => client.post("/family/verify-pin", { pin }).then((r) => r.data),
  changePin: (new_pin) => client.post("/family/change-pin", { new_pin }).then((r) => r.data),
  resetComp: () => client.post("/family/reset").then((r) => r.data),
  deleteFamily: () => client.delete("/family").then((r) => r.data),

  listMembers: () => client.get("/members").then((r) => r.data),
  addMember: (payload) => client.post("/members", payload).then((r) => r.data),
  updateMember: (id, payload) => client.put(`/members/${id}`, payload).then((r) => r.data),
  deleteMember: (id) => client.delete(`/members/${id}`).then((r) => r.data),

  listCatches: () => client.get("/catches").then((r) => r.data),
  addCatch: (payload) => client.post("/catches", payload).then((r) => r.data),
  updateCatch: (id, payload) => client.put(`/catches/${id}`, payload).then((r) => r.data),
  deleteCatch: (id) => client.delete(`/catches/${id}`).then((r) => r.data),
  toggleBulldust: (id, user_id) =>
    client.post(`/catches/${id}/bulldust`, { user_id }).then((r) => r.data),
  exportCsvUrl: () => `${API}/catches/export`,
};
